import { BRAND } from "../lib/brand";

// Official Spirit Admin logo — meditating-figure profile icon in a glowing circular frame
export default function Logo({ size = 30, withText = true, className = "", textClassName = "" }) {
  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <span className="relative inline-flex items-center justify-center shrink-0" style={{ width: size, height: size }}>
        <span className="absolute inset-0 rounded-full bg-[#4da6ff] blur-md opacity-50" />
        <img src={BRAND.icon} alt="Spirit Admin" className="relative rounded-full object-cover border border-[#4da6ff]/40"
          style={{ width: size, height: size, boxShadow: "0 0 14px rgba(77,166,255,0.45)" }} />
      </span>
      {withText && <span className={`font-head font-semibold tracking-tight ${textClassName}`}>Spirit Admin</span>}
    </span>
  );
}
